import { render, staticRenderFns } from "./ContasPagarLista.vue?vue&type=template&id=50b8f954&scoped=true&"
import script from "./ContasPagarLista.vue?vue&type=script&lang=js&"
export * from "./ContasPagarLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b8f954",
  null
  
)

export default component.exports